import { createReducer } from 'typesafe-actions';
import { UPDATE_PROFILE_FIELD, INIT_PROFILE_EDIT_FIELD } from './actions';
import {
  initialState as initialEditState,
  MyPageAction,
  EditProfileInputField
} from './types';

export const profile = createReducer<EditProfileInputField, MyPageAction>(
  initialEditState,
  {
    [INIT_PROFILE_EDIT_FIELD]: () => {
      return initialEditState;
    },
    [UPDATE_PROFILE_FIELD]: (state, action) => ({
      ...state,
      ...action.payload
    })
  }
);
